module.exports = __webpack_public_path__ + "media/form-type-page/money-check-alt-f538e6fb.svg";